import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import cookies from 'js-cookie';

const PrivateRoute = ({component: Component, ...rest}) => {
    let authToken = cookies.get('auth_token');
    return (
        <Route {...rest} render={props => (
            authToken ?
                <Component {...props} />
            : <Redirect to="/login" />
        )} />
    );
};

export default PrivateRoute;